import classes from "../homePageNew.module.css";
import { ENTITY_LABELS } from "../../../utils/labelMapping";
import { rbiWeightLabel } from "../../../utils/brandIndexCalc";

// Labels come from ENTITY_LABELS (read live, not at module scope, since it's
// a Proxy over the current customer's UI terminology overrides) — same
// source DiscoveryV2/Competitors/CompetitorItem.js uses for these same four
// metrics, so a customer's custom terminology matches across both.
function buildMetrics(isProduct) {
  return [
    { key: "visibility", label: ENTITY_LABELS.rank, weight: rbiWeightLabel("visibility"), color: "var(--hpn-d-blue)", max: 50, decimals: 0 },
    { key: "sentiment", label: "Sentiment", weight: rbiWeightLabel("sentiment"), color: "var(--hpn-d-orange)", max: 50, decimals: 0 },
    {
      key: "brandPillars",
      label: isProduct ? ENTITY_LABELS.productDimension : ENTITY_LABELS.brandPillar,
      weight: rbiWeightLabel("brandPillars"),
      color: "var(--hpn-d-purple)",
      max: 10,
      decimals: 1,
    },
    { key: "purchaseCriteria", label: ENTITY_LABELS.purchaseCriteria, weight: rbiWeightLabel("purchaseCriteria"), color: "var(--hpn-d-green)", max: 10, decimals: 1 },
  ];
}

// `isProduct` swaps the "Brand Pillars" slot's label to "Product Dimension"
// for Product-type discovery runs — same slot/weight, same source data field
// (scores.brand_pillars_score), just a different real-world meaning per
// DiscoveryV2/Taxonomy/Taxonomy.js's own ENTITY_LABELS.productDimension use.
export default function MetricGrid({ visibility, sentiment, brandPillars, purchaseCriteria, isProduct = false }) {
  const values = { visibility, sentiment, brandPillars, purchaseCriteria };
  const METRICS = buildMetrics(isProduct);
  return (
    <div className={classes.metricGridWide}>
      {METRICS.map((m) => {
        const raw = values[m.key];
        const display = raw == null ? "—" : Number(raw).toFixed(m.decimals);
        return (
          <div className={classes.metricChip} key={m.key}>
            <div className={classes.mh}>
              <span>
                <span className={classes.dot} style={{ background: m.color }} />
                {m.label}
              </span>
              <span className={classes.wt}>{m.weight}</span>
            </div>
            <div className={classes.mv}>
              {display}
              <small>/{m.max}</small>
            </div>
            <div className={classes.metricFillTrack}>
              <div
                className={classes.metricFillBar}
                style={{
                  width: `${raw == null ? 0 : Math.min(100, Math.max(0, (Number(raw) / m.max) * 100))}%`,
                  background: m.color,
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
